<template>
  <div>
    <div class="status_block" :id="'status' + randomId">
      <template v-for="(item, i) in list">
        <v-hover :key="i" v-slot="{ hover }">
          <button
            v-if="item.status === 'error' ? status === 'error' : item.status === 'deleted' ? status === 'deleted' : true"
            class="inert"
            :class="hover || item.status === status
            ? 'color_' + item.status
            : active.includes(item.status) ? '' : ' disabled'"
            :disabled="finSystem === 'manual'
              ? !active.includes(item.status)
              : item.status === status
                ? status !== 'error' && status !== 'delete'
                : true"
            @click="askChangeStatus(item)"
          >
            {{ item.name }}
          </button>
          <div v-else/>
        </v-hover>
      </template>
    </div>
    <v-dialog width="600" v-if="dialog" v-model="dialog">
      <v-card class="pa-10">
        <v-btn icon absolute right top class="mt-n2 mr-n2" @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="d-flex flex-column justify-center align-center">
          <div class="f30">
            {{finSystem === 'manual' ? localStorage.translations.pages.common['buttons']['primenit'] + '?' : temp.name}}
          </div>
          <IconsFinanceInvoice :color="temp.color" class="mt-5 mb-3"/>
          <template v-if="finSystem === 'manual'">
            <div>{{ temp.name }}</div>
          </template>
          <template v-else>
            <div v-if="systemData.error" class="text-center">
              <div><span class="secondary--text">msgKey: </span>{{ systemData.error['msgKey'] }}</div>
              <div><span class="secondary--text">message: </span>{{ systemData.error['message'] }}</div>
            </div>
            <div v-if="systemData.status" class="text-center">
              <div><span class="secondary--text">status: </span>{{ systemData.status }}</div>
            </div>
          </template>
        </div>
        <div class="d-flex justify-space-around mt-4">
          <template v-if="finSystem === 'manual'">
            <v-hover v-slot="{ hover }">
              <v-btn fab :outlined="!hover" :dark="hover" color="red" @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <v-hover v-slot="{ hover }">
            <v-btn
              fab
              depressed
              :outlined="!hover"
              :dark="hover"
              color="#277FAF"
              @click="finSystem === 'manual' ? changeStatus(temp.status) : dialog = false"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-hover>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import IconsFinanceInvoice from "components/icons/finance/IconsFinanceInvoice";

export default {
  name: "FinanceInvoiceShowStatus",
  components: {IconsFinanceInvoice},
  props: {
    status: {
      type: String,
      default: ''
    },
    onChangeStatus: {},
    systemData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    finSystem: {
      type: String,
      default: 'manual'
    }
  },
  computed: {
    ...mapGetters('workClientProjectsClientBills', ['workClientProjectsClientBillStatuses']),

    randomId() {
      let min = Math.ceil(1)
      let max = Math.floor(1000)
      return 'table_' + Math.floor(Math.random() * (max - min + 1)) + min
    },
    list() {
      let temp = []
      if (this.finSystem === 'manual') {
        temp = ['new', 'sent', 'paid_partly', 'paid']
      }
      else if (this.finSystem === 'netvisor') {
        temp = ['new', 'imported', 'paid']
      }
      else {
        temp = ['new', 'import_in_progress', 'error', 'imported', 'deleted', 'sent', 'pending_payment', 'paid_partly', 'paid']
      }
      let result = []
      for (let i in temp) {
        let element = this.workClientProjectsClientBillStatuses.filter(f => f.status == temp[i])[0]
        if (element.translation === 'imported' && this.finSystem === 'netvisor')
          result.push({
            name: this.localStorage.translations.pages.finance['invoice-status']['imported_netvisor'],
            color: element.color,
            status: element.status
          })
         else if (element.translation === 'imported' && this.finSystem === 'procountor')
          result.push({
            name: this.localStorage.translations.pages.finance['invoice-status']['imported_procountor'],
            color: element.color,
            status: element.status
         })
        else result.push({
          name: this.localStorage.translations.pages.finance['invoice-status'][element.translation],
          color: element.color,
          status: element.status
        })
      }
      return result
    },
    active() {
      if (this.finSystem === 'manual') {
        switch (this.status) {
          case null:
            return ['new']
          case 'new':
            return ['sent']
          case 'sent':
            return ['paid_partly', 'paid', 'canceled']
          case 'paid_partly':
            return ['paid', 'canceled']
          default:
            return []
        }
      } else return []
    },
  },
  data: () => ({
    dialog: false,
    temp: {},
  }),
  methods: {
    askChangeStatus(status) {
      this.temp = status
      this.dialog = true
    },
    changeStatus(status) {
      if (this.onChangeStatus) {
        this.onChangeStatus(status)
        this.temp = {}
        this.dialog = false
      }
    }
  }
}
</script>

<style scoped lang="scss">

$inert: #dedede;
$colors: (
  'new': #277FAF,
  'import_in_progress': #F2C94C,
  'error': #EB5757,
  'imported': #33B0AA,
  'deleted': #EB5757,
  'sent': #f5a967,
  'pending_payment': #F2994A,
  'paid_partly': #A5EEB3,
  'paid': #219653,
  'archived': #C3C3C3,
  'canceled': #EB5757,
);

.status_block {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.inert {
  padding: 4px 8px;
  margin: 2px 10px;
  position: relative;
  background-color: $inert;
  height: 32px;
  min-width: 200px;

  &::before {
    position: absolute;
    top: 0;
    left: -16px;
    width: 0;
    height: 0;
    content: '';
    border-top: 16px solid $inert;
    border-bottom: 16px solid $inert;
    border-left: 16px solid transparent;
  }

  &::after {
    position: absolute;
    top: 0;
    right: -16px;
    width: 0;
    height: 0;
    content: '';
    border-top: 16px solid transparent;
    border-bottom: 16px solid transparent;
    border-left: 16px solid $inert;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    padding-left: 16px;

    &::before {
      border: none;
    }
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    padding-right: 16px;

    &::after {
      border: none;
    }
  }

  &.disabled {
    color: #b8b8b8;
  }
}

@each $name, $color in $colors {
  .color_#{$name} {
    color: white;
    background-color: $color;

    &::before {
      border-top: 16px solid $color;
      border-bottom: 16px solid $color;
    }

    &::after {
      border-left: 16px solid $color;
    }
  }
}
</style>
